import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  widthHack: {
    minWidth: '1.75rem'
  }
});

class PaginationDisplay extends Component {
  constructor(props) {
    super(props);

    this.updateButton = this.updateButton.bind(this);
  }

  updateButton(page) {
    // if(!page) return;
    return this.props.updatePage(page);
  }

  render() {  
    return(
      <Grid 
        className="h-100"
        alignItems="center"
        container>
        {/*<Grid 
          className={'opacity-transition ' + this.props.classes.widthHack}
          item>
          {(this.props.currentPageNumber - 1 > -1) &&
            <div onClick={this.updateButton.bind(this, 0)} className="pagination-button"></div>
          }
        </Grid>*/}
        <Grid 
          item
          className={'opacity-transition ' + this.props.classes.widthHack}>
          {(this.props.currentPageNumber - 1 > 0) &&
            <div onClick={this.updateButton.bind(this, this.props.currentPageNumber - 1)} className="page-change prev"></div>
          }
        </Grid>
        <Grid className="white current" item>
          {this.props.currentPageNumber}
            <br/>
            {/*this.props.currentPageNumber > 0 &&
              <span className="blue pointer" onClick={this.props.getLeaderboard.bind(this)}>Reset Leaderboard</span>
            */}
        </Grid>
        <Grid 
          item
          className={'opacity-transition ' + this.props.classes.widthHack}>
          {(this.props.currentPageNumber < this.props.lastPageNumber) &&
            <div onClick={this.updateButton.bind(this, this.props.currentPageNumber + 1)} className="page-change next"></div>
          }
        </Grid>
        {/*<Grid 
          item
          className={'opacity-transition ' + this.props.classes.widthHack}>
          {(this.props.lastPageNumber > this.props.currentPageNumber) && 
            (this.props.currentPageNumber < this.props.lastPageNumber) &&
            <div onClick={this.updateButton.bind(this, this.props.lastPageNumber)} className="pagination-button fwd"></div>
          }    
        </Grid>*/}
      </Grid>
    )
  }
}

PaginationDisplay.propTypes = {
  currentPageNumber: PropTypes.number.isRequired,
  updatePage: PropTypes.func.isRequired,
  lastPageNumber: PropTypes.number,
  classes: PropTypes.object.isRequired,
  // getLeaderboard: PropTypes.func.isRequired
}

export default withStyles(styles)(PaginationDisplay);